import { v4 as uuidV4 } from 'uuid';
import validateUuid from 'uuid-validate';
import ModelMeta from './ModelMeta';
export class AbstractEntity {
    _id;
    meta;
    constructor(id) {
        if (id) {
            AbstractEntity.validateId(id);
            this._id = id;
        }
        else {
            this._id = uuidV4();
        }
        this.meta = new ModelMeta();
    }
    static createRef(id) {
        AbstractEntity.validateId(id);
        return { _id: id };
    }
    static createRefFromEntity(entity) {
        AbstractEntity.validateId(entity._id);
        return { _id: entity._id };
    }
    static validateId(id) {
        if (!validateUuid(id, 4) && !validateUuid(id, 5)) {
            throw new Error(`Id must be a valid uuidV4 or uuidV5 string. Given ${id}`);
        }
    }
}
//# sourceMappingURL=AbstractEntity.js.map